$ = jQuery;

function header() {
  $(document).ready(function () {

    // Mobile toggle
    $('.navbar-toggler').on('click', function () {
      $('.collapse.navbar-collapse').toggleClass('show');
      $(this).toggleClass('opened');
      $('body').toggleClass('opened-navigation');
    });

    const desktopMenu = window.matchMedia('(min-width: 992px)');

    function initDesktopHoverMenu(e) {

      // clear previous events
      $('.content-header .menu--main ul li a.dropdown-toggle')
      .off('mouseenter mouseleave');
      $('.dropdown-menu.sub-menu')
      .off('mouseenter mouseleave');

      if (e.matches) {
        // DESKTOP hover
        $('.content-header .menu--main ul li a.dropdown-toggle')
        .on('mouseenter', function () {
          $(this).siblings('.dropdown-menu').addClass('show');
        })
        .on('mouseleave', function () {
          $(this).siblings('.dropdown-menu').removeClass('show');
        });

        $('.dropdown-menu.sub-menu')
        .on('mouseenter', function () {
          $(this).addClass('show');
        })
        .on('mouseleave', function () {
          $(this).removeClass('show');
        });
      }
    }

    // first load
    initDesktopHoverMenu(desktopMenu);

    // on resize screen
    desktopMenu.addEventListener('change', initDesktopHoverMenu);

    $('.submenu-toggler').click(function() {
      $(this).siblings('.sub-menu').toggleClass('show');
    });

    $('.sub-menu-title').click(function() {
      $(this).parents('.dropdown-menu').toggleClass('show');
    })
  });
}
